import PropTypes from 'prop-types';

const ENVS = ['dev', 'stg', 'prod'];

/**
 * Checks whether the current app environment is enabled.
 *
 * @param {Array<'dev' | 'stg' | 'prod'>} envs - Environments where the feature is enabled
 * @returns {boolean}
 */
export const featureFlag = (envs) => {
	if (!Array.isArray(envs)) return false;

	return envs.includes(process.env.REACT_APP_ENV);
};

/**
 * Conditionally renders children based on the current environment.
 *
 * @param {Object} props
 * @param {Array<'dev' | 'stg' | 'prod'>} props.envs - Environments where children should render
 * @param {React.ReactNode} props.children
 * @returns {React.ReactNode | null}
 */
const FeatureFlag = ({ envs, children }) => {
	if (!featureFlag(envs)) return null;

	return children;
};

FeatureFlag.propTypes = {
	envs: PropTypes.arrayOf(PropTypes.oneOf(ENVS)).isRequired,
	children: PropTypes.node.isRequired,
};

export default FeatureFlag;
